module.exports = __webpack_public_path__ + "static/media/kh.b3dadd9f.svg";